/* eslint-disable no-undef */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable react/no-array-index-key */
import React from 'react';
import { observer } from 'mobx-react';
import { Utils } from 'Utils/utils';
import { companySearchState } from 'Stores/companySearch';
import { userDetail } from 'Stores/userDetail';
import * as CONSTANTS from 'Utils/constants';
import { ReactComponent as CopyIcon } from 'Assets/svg/copy.svg';
import { ReactComponent as CompanyPhoneIcon } from 'Assets/svg/contact-phone.svg';
import { purchaseStatusPopupState } from '../purchaseStatusPopup';
import { PhoneItem } from '../ContactList/ContactPhone';

const CompanyEmailPhone = observer(props => {
  const {
    contactId,
    phone = '',
    isDownloaded = false,
    pageName = 'advsearch',
    showCopyIcon = false,
  } = props;

  const { userInfo, featureFlags } = userDetail;
  const { downloads, memberSubscription, lbCredits } = userInfo;

  const { COPY_RESTRICTION = false } = featureFlags;

  const downloadContactCopy = (e, id, isDownload) => {
    const str = e.currentTarget.getAttribute('data-value');
    if (
      (Utils.isCreditBasedSubscription() && lbCredits > 0) ||
      (!Utils.isCreditBasedSubscription() && downloads > 0) ||
      isDownload ||
      COPY_RESTRICTION === false ||
      Utils.isCreditsWithinMonthlyLimit()
    ) {
      Utils.copyToClipBoard(str);
      purchaseStatusPopupState.setToastMsg(null, null, null, true);
    } else {
      Utils.mixpanelTrack(CONSTANTS.MX_AS_EVENTS.AS_DOWNLOAD_EXPIRED, {});
      if (memberSubscription !== null && memberSubscription !== undefined)
        Utils.showCreditExpiredPopup('downloads');
      else Utils.showUserPricingPopup(true, 'downloads', false);
    }
  };

  const copyContactInfo = e => {
    const str = e.currentTarget.getAttribute('data-value');
    e.preventDefault();

    Utils.copyToClipBoard(str);
    purchaseStatusPopupState.setToastMsg(null, null, null, true);
  };

  const PhoneTemplate = observer(prop => {
    const { clsName, shortName, phoneNumber = '', tooltip } = prop;

    return <PhoneItem phoneNumber={phoneNumber} type="company" />;
  });

  const RenderPhone = () => {
    const phoneView = [];

    if (phone !== undefined && phone !== null && phone !== '')
      phoneView.push(
        <PhoneTemplate
          key="company-line"
          clsName="company-line"
          shortName="C"
          tooltip="Click to copy"
          phoneNumber={phone}
        />,
      );

    return phoneView;
  };

  return (
    <div className="contact-info">
      <div className={`contact-phone${showCopyIcon ? ' show-copy' : ''}`}>
        <RenderPhone />
      </div>
    </div>
  );
});

export { CompanyEmailPhone };
export default CompanyEmailPhone;
